// import { Mojs } from 'mojs';

export enum PollSimpleOptions {
  OPTION1 = 'option1',
  OPTION2 = 'option2',
  OPTION3 = 'option3',
}

// function isIOSSafari() {
//   const userAgent = window.navigator.userAgent;
//   return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
// }

// function isTouch() {
//   let isIETouch: boolean | undefined;
//   isIETouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
//   return Array.prototype.indexOf.call(window, 'ontouchstart') >= 0 || isIETouch;
// }

// const isIOS = isIOSSafari();
// let clickHandler: string = isIOS || isTouch() ? 'touchstart' : 'click';

// interface Options {
//   tweens?: Mojs.Tween[];
//   onCheck?(): void;
//   onUnCheck?(): void;
// }

// class AnimateIcon {
//   el: HTMLElement;
//   options: Options;

//   constructor(el: HTMLElement, options: Options) {
//     this.el = el;
//     this.options = extend({}, options);
//   }

//   checked: boolean = false;
//   timeline: Mojs.Timeline | undefined;

//   init() {
//     this.timeline = new Mojs.Timeline();
//     for (let i = 0, len = this.options.tweens.length; i < len; i++)
